import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_796424c0 from 'nuxt_plugin_plugin_796424c0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_19eb4f6c from 'nuxt_plugin_nuxtsvgsprite_19eb4f6c' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_globalthis_2f134e7e from 'nuxt_plugin_globalthis_2f134e7e' // Source: ./nuxt-polyfill/@ungap/global-this.js (mode: 'all')
import nuxt_plugin_smoothscrollpolyfill_298dad8e from 'nuxt_plugin_smoothscrollpolyfill_298dad8e' // Source: ./nuxt-polyfill/smoothscroll-polyfill.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_c01e41d2 from 'nuxt_plugin_nuxtuseragent_c01e41d2' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_apollomodule_2d04fb9a from 'nuxt_plugin_apollomodule_2d04fb9a' // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_requestcontext_fe1611dc from 'nuxt_plugin_requestcontext_fe1611dc' // Source: ../plugins/request-context.ts (mode: 'all')
import nuxt_plugin_performancelogger_8b0146ec from 'nuxt_plugin_performancelogger_8b0146ec' // Source: ../plugins/performance-logger.ts (mode: 'all')
import nuxt_plugin_vueagile_6bd42cd0 from 'nuxt_plugin_vueagile_6bd42cd0' // Source: ../plugins/vue-agile.js (mode: 'all')
import nuxt_plugin_basis_e67e4b22 from 'nuxt_plugin_basis_e67e4b22' // Source: ../plugins/basis.js (mode: 'all')
import nuxt_plugin_sanitaizehtml_76b037c7 from 'nuxt_plugin_sanitaizehtml_76b037c7' // Source: ../plugins/sanitaize-html.js (mode: 'all')
import nuxt_plugin_api_7852046e from 'nuxt_plugin_api_7852046e' // Source: ../plugins/api.ts (mode: 'all')
import nuxt_plugin_htmlWithScripts_8fe39054 from 'nuxt_plugin_htmlWithScripts_8fe39054' // Source: ../plugins/htmlWithScripts.js (mode: 'all')
import nuxt_plugin_globalComponents_61ab9908 from 'nuxt_plugin_globalComponents_61ab9908' // Source: ../plugins/globalComponents.js (mode: 'all')
import nuxt_plugin_vmask_06f53101 from 'nuxt_plugin_vmask_06f53101' // Source: ../plugins/vmask.ts (mode: 'client')
import nuxt_plugin_clickOutside_0ea087a4 from 'nuxt_plugin_clickOutside_0ea087a4' // Source: ../plugins/clickOutside.js (mode: 'client')
import nuxt_plugin_hammer_4dbbcbf1 from 'nuxt_plugin_hammer_4dbbcbf1' // Source: ../plugins/hammer.ts (mode: 'client')
import nuxt_plugin_animation_af394b2e from 'nuxt_plugin_animation_af394b2e' // Source: ../plugins/animation.js (mode: 'all')
import nuxt_plugin_directives_521c021a from 'nuxt_plugin_directives_521c021a' // Source: ../plugins/directives.ts (mode: 'client')
import nuxt_plugin_router_79dc5c8e from 'nuxt_plugin_router_79dc5c8e' // Source: ../plugins/router.ts (mode: 'all')
import nuxt_plugin_anchorscrollclient_4401d183 from 'nuxt_plugin_anchorscrollclient_4401d183' // Source: ../plugins/anchor-scroll.client.ts (mode: 'client')
import nuxt_plugin_vuetyped_438b3d60 from 'nuxt_plugin_vuetyped_438b3d60' // Source: ../plugins/vue-typed.ts (mode: 'client')
import nuxt_plugin_meta_7dd69e9c from 'nuxt_plugin_meta_7dd69e9c' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"ru","xmlns:og":"http:\u002F\u002Fogp.me\u002Fns#"},"title":"rgs.ru","link":[{"rel":"icon","sizes":"16x16","type":"image\u002Fpng","href":"\u002Ffavicon-16x16.png"},{"rel":"icon","sizes":"32x32","type":"image\u002Fpng","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fico","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon-180x180.png"},{"rel":"manifest","href":"\u002Fmanifest.json"}],"style":[{"hid":"varioqub-antiflicker-style","innerHTML":".varioqub-antiflicker {opacity: 0 !important;}","type":"text\u002Fcss"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover, interactive-widget=resizes-content"},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#b70037"},{"name":"theme-color","content":"#b70037"},{"property":"og:locale","content":"ru_RU"},{"property":"og:type","content":"website"},{"name":"yandex-verification","content":"a60de3705349da49"},{"name":"yandex-verification","content":"daf0840e76eb022b"}],"__dangerouslyDisableSanitizers":["script","noscript"],"__dangerouslyDisableSanitizersByTagID":{"varioqub-antiflicker-style":["innerHTML"]},"script":[{"hid":"microformat","innerHTML":"\n    {\n      \"@context\": \"http:\u002F\u002Fschema.org\",\n      \"@type\": \"Organization\",\n      \"name\": \"Росгосстрах❤️\",\n      \"logo\": \"https:\u002F\u002Fwww.rgs.ru\u002Fupload\u002Fmedialibrary\u002F998\u002Flogo_1200_1.jpg\",\n      \"url\": \"https:\u002F\u002Fwww.rgs.ru\u002F\",\n      \"address\": { \"@type\": \"PostalAddress\", \"addressCountry\": \"Russian Federation\" },\n      \"sameAs\": []\n    }\n  ","type":"application\u002Fld+json","charset":"utf-8"},{"charset":"UTF-8","innerHTML":"window['adrum-start-time'] = new Date().getTime();\n              window['adrum-config'] = {\n                  xhr: {\n                      maxPerPageView: \"UNLIMITED\",\n                  }\n              };\n              (function(config){\n                  config.appKey = 'EUM-AAB-AUS';\n                  config.adrumExtUrlHttp = 'http:\u002F\u002Fwww.rgs.ru\u002Fscripts';\n                  config.adrumExtUrlHttps = 'https:\u002F\u002Fwww.rgs.ru\u002Fscripts';\n                  config.beaconUrlHttp = 'http:\u002F\u002Fappd-eum.rgs.ru';\n                  config.beaconUrlHttps = 'https:\u002F\u002Fappd-eum.rgs.ru';\n                  config.applicationName = 'undefined';\n                  config.xd = {enable : true};\n\n                  config.page={\n                      captureTitle:true\n                  };\n\n                  config.fetch=true;\n\n                  config.enableCoreWebVitals = true;\n                  config.isZonePromise=true;\n                  config.spa = {\n                      \"spa2\": true\n                  };\n\n              })(window['adrum-config'] || (window['adrum-config'] = {}));"},{"charset":"utf-8","type":"text\u002Fjavascript","innerHTML":"(function(a,n,t,i,f,li,c,k,e,r){\n        a[t]=a[t]||function(){(a[t].a=a[t].a||[]).push(arguments)};n.classList.add(i);c=function(){n.classList.remove(i)};li.callback=c;a[t].antiFlicker=li;setTimeout(c,f);\n    })(window, document.documentElement, 'ymab', 'varioqub-antiflicker', 6000, { 'metrika.89215432': true });"},{"charset":"utf-8","type":"text\u002Fjavascript","innerHTML":"(function(e, x, pe, r, i, me, nt){\n            e[i]=e[i]||function(){(e[i].a=e[i].a||[]).push(arguments)},\n            me=x.createElement(pe),me.async=1,me.src=r,nt=x.getElementsByTagName(pe)[0],me.addEventListener(\"error\",function(){function cb(t){t=t[t.length-1],\"function\"==typeof t&&t({flags:{}})};Array.isArray(e[i].a)&&e[i].a.forEach(cb);e[i]=function(){cb(arguments)}}),nt.parentNode.insertBefore(me,nt)})\n            (window, document, 'script', 'https:\u002F\u002Fabt.s3.yandex.net\u002Fexpjs\u002Flatest\u002Fexp.js', 'ymab');"},{"charset":"utf-8","type":"text\u002Fjavascript","innerHTML":"(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n         m[i].l=1*new Date();\n         for (var j = 0; j \u003C document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n         k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n         (window, document, \"script\", \"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js\", \"ym\");\n\n   ym(396811, \"init\", {\n        cookieDomain:'.rgs.ru',\n        trustedDomains: ['rgs.ru','www.rgs.ru','partner.rgs.ru','pulse.rgs.ru','lk.pulse.insure'],\n        clickmap: true,\n        trackLinks: true,\n        accurateTrackBounce: true,\n        webvisor: true,\n        childIframe:true,\n        ecommerce: \"dataLayer\",\n        defer: true,\n        trustedProcessIframe: true\n        }\n    );\n\n    ym(89215432, \"init\", {\n        trustedDomains: ['rgs.ru','www.rgs.ru','partner.rgs.ru','pulse.rgs.ru','lk.pulse.insure'],\n        childIframe: true,\n        clickmap: true,\n        trackLinks: true,\n        accurateTrackBounce: true,\n        webvisor: false\n    });"},{"type":"text\u002Fjavascript","src":"\u002Fscripts\u002Fadrum.js","defer":"defer"}],"noscript":[{"innerHTML":"\u003Cdiv\u003E\u003Cimg src=\"https:\u002F\u002Fmc.yandex.ru\u002Fwatch\u002F396811\" style=\"position:absolute; left:-9999px;\" alt=\"\" \u002F\u003E\u003Cimg src=\"https:\u002F\u002Fmc.yandex.ru\u002Fwatch\u002F89215432\" style=\"position:absolute; left:-9999px;\" alt=\"\" \u002F\u003E\u003C\u002Fdiv\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_796424c0 === 'function') {
    await nuxt_plugin_plugin_796424c0(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_19eb4f6c === 'function') {
    await nuxt_plugin_nuxtsvgsprite_19eb4f6c(app.context, inject)
  }

  if (typeof nuxt_plugin_globalthis_2f134e7e === 'function') {
    await nuxt_plugin_globalthis_2f134e7e(app.context, inject)
  }

  if (typeof nuxt_plugin_smoothscrollpolyfill_298dad8e === 'function') {
    await nuxt_plugin_smoothscrollpolyfill_298dad8e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_c01e41d2 === 'function') {
    await nuxt_plugin_nuxtuseragent_c01e41d2(app.context, inject)
  }

  if (typeof nuxt_plugin_apollomodule_2d04fb9a === 'function') {
    await nuxt_plugin_apollomodule_2d04fb9a(app.context, inject)
  }

  if (typeof nuxt_plugin_requestcontext_fe1611dc === 'function') {
    await nuxt_plugin_requestcontext_fe1611dc(app.context, inject)
  }

  if (typeof nuxt_plugin_performancelogger_8b0146ec === 'function') {
    await nuxt_plugin_performancelogger_8b0146ec(app.context, inject)
  }

  if (typeof nuxt_plugin_vueagile_6bd42cd0 === 'function') {
    await nuxt_plugin_vueagile_6bd42cd0(app.context, inject)
  }

  if (typeof nuxt_plugin_basis_e67e4b22 === 'function') {
    await nuxt_plugin_basis_e67e4b22(app.context, inject)
  }

  if (typeof nuxt_plugin_sanitaizehtml_76b037c7 === 'function') {
    await nuxt_plugin_sanitaizehtml_76b037c7(app.context, inject)
  }

  if (typeof nuxt_plugin_api_7852046e === 'function') {
    await nuxt_plugin_api_7852046e(app.context, inject)
  }

  if (typeof nuxt_plugin_htmlWithScripts_8fe39054 === 'function') {
    await nuxt_plugin_htmlWithScripts_8fe39054(app.context, inject)
  }

  if (typeof nuxt_plugin_globalComponents_61ab9908 === 'function') {
    await nuxt_plugin_globalComponents_61ab9908(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmask_06f53101 === 'function') {
    await nuxt_plugin_vmask_06f53101(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clickOutside_0ea087a4 === 'function') {
    await nuxt_plugin_clickOutside_0ea087a4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hammer_4dbbcbf1 === 'function') {
    await nuxt_plugin_hammer_4dbbcbf1(app.context, inject)
  }

  if (typeof nuxt_plugin_animation_af394b2e === 'function') {
    await nuxt_plugin_animation_af394b2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c021a === 'function') {
    await nuxt_plugin_directives_521c021a(app.context, inject)
  }

  if (typeof nuxt_plugin_router_79dc5c8e === 'function') {
    await nuxt_plugin_router_79dc5c8e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_anchorscrollclient_4401d183 === 'function') {
    await nuxt_plugin_anchorscrollclient_4401d183(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetyped_438b3d60 === 'function') {
    await nuxt_plugin_vuetyped_438b3d60(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_7dd69e9c === 'function') {
    await nuxt_plugin_meta_7dd69e9c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
